<template>
  <div class="fit flex overflow-hidden flex-no-wrap">
    <!-- {{ store.state.profile }} -->
    <div class="flex-1 h-full relative">
      <CarComp
        v-model="position.model"
        :ui="uiButtons"
        v-if="
          !['BOAT', 'LORRY/TRUCK', 'MACHINERY'].includes(
            store.state.profile.type,
          )
        "
      />
      <ForkliftComp
        v-model="position.model"
        :ui="uiButtons"
        v-if="store.state.profile.type == 'MACHINERY'"
      />
      <TruckComp
        v-if="store.state.profile.type == 'LORRY/TRUCK'"
        v-model="position.model"
        :ui="uiButtons"
        :tyre="store.state.config.tyre"
      />
      <BoatComp
        v-model="position.model"
        :ui="uiButtons"
        v-if="store.state.profile.type == 'BOAT'"
      />
      <q-btn
        v-if="position.model != 'general'"
        color="primary"
        label="Back To Overview"
        @click="position.model = 'general'"
        class="absolute left-0 top-0 m-4"
      />
    </div>
    <q-separator vertical />
    <div
      class="overflow-hidden flex-1 flex flex-col flex-no-wrap z-10 shadow bg-"
      style="
        container-type: size;
        backdrop-filter: blur(50px);
        background-color: rgba(255, 255, 255, 0.749);
      "
      v-if="renderGeneral"
    >
      <div
        class="flex flex-col gap-1 p-2 flex-no-wrap"
        style="height: 100cqh"
        v-if="true"
      >
        <FormInput :data="position" v-model="position.model" />
        <q-separator spaced />
        <div
          class="flex-1 flex flex-col gap-1 flex-no-wrap bg- overflow-auto"
          v-if="currentData"
        >
          <q-tabs v-model="tab" class="text-teal" dense>
            <q-tab name="form" label="Details" />
            <q-tab name="table" label="Service Records" />
          </q-tabs>
          <q-tab-panels v-model="tab" animated class="flex-1 overflow-hidden">
            <q-tab-panel
              name="form"
              class="gap-1 flex-col flex-1 flex-no-wrap flex overflow-auto"
            >
              <FormInput
                v-for="(tire, i) in ui"
                :key="i"
                :data="tire"
                v-model="currentData[tire.model]"
              />
            </q-tab-panel>
            <q-tab-panel name="table" class="flex-1 overflow-hidden">
              <div class="w-full bg-white p-2 rounded-lg h-full flex">
                <MaintenanceTable
                  data="tyre"
                  :tyre="position.model"
                  @add="rerender"
                  @remove="rerender"
                />
              </div>
            </q-tab-panel>
          </q-tab-panels>
          <q-btn
            color="danger"
            icon="delete_outline"
            label="Remove Data"
            @click="modifyData(position.model)"
          />
        </div>
        <div
          class="flex-1 flex flex-col gap-1 flex-no-wrap bg-"
          v-if="!currentData && position.model != 'general'"
        >
          <span>No Data for this unit</span>
          <q-btn
            color="primary"
            icon="add"
            label="Add Data"
            @click="modifyData(position.model, true)"
          />
        </div>
        <div
          class="flex-1 flex flex-col gap-1 flex-no-wrap bg-"
          v-if="position.model == 'general'"
        >
          <span>Please select a unit to view the details</span>
          <div class="flex flex-col gap-2">
            <div class="" v-for="(pos, key) in uiButtons">
              <div class="flex flex-col gap-2" v-if="pos.length > 0">
                <div class="capitalize font-bold">{{ key }}</div>
                <div class="flex gap-2">
                  <q-btn
                    v-for="btn in pos"
                    color="primary"
                    :outline="!store.state.tyre[btn] ? true : false"
                    :label="btn"
                    @click="position.model = btn"
                  />
                </div>
              </div>
            </div>
            <!-- <pre>{{ uiButtons }}</pre> -->
          </div>
        </div>
      </div>
    </div>
    <div
      class="fit absolute left-0 top-0 bg-grey-light opacity-50 flex z-50 flex-center"
      v-if="!renderGeneral"
    >
      Loading
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';

import { store } from '../../api/api';

import CarComp from './CarComp.vue';
import BoatComp from './BoatComp.vue';
import TruckComp from './TruckComp.vue';
import ForkliftComp from './ForkliftComp.vue';
import MaintenanceTable from '../components/MaintenanceTable.vue';
import FormInput from '../components/FormInput.vue';

const tab = ref('form');

const position = ref({
  label: 'Position',
  model: 'general',
  options: [],
});

const uiButtons = computed(() => {
  if (position.value.options.length == 0) return;
  const separatedObject = position.value.options.reduce((acc, item) => {
    const category = item.substring(0, 2);
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(item);
    return acc;
  }, {});

  // Define the result object with empty arrays for each category
  const result = {
    front: [],
    middle: [],
    back: [],
  };

  // Loop through the separatedObject and populate the result object
  for (const key in separatedObject) {
    if (key.startsWith('FL') || key.startsWith('FR')) {
      result.front.push(...separatedObject[key]);
    } else if (key.startsWith('ML') || key.startsWith('MR')) {
      result.middle.push(...separatedObject[key]);
    } else if (key.startsWith('BL') || key.startsWith('BR')) {
      result.back.push(...separatedObject[key]);
    }
  }
  return result;
});

const renderGeneral = ref(true);
watch(
  () => store.state.config.tyre,
  () => {
    if (store.state.config.tyre) {
      position.value.options = createTyreOptions();
      rerender();
    }
  },
  { deep: true, immediate: true },
);

function createTyreOptions() {
  let tyre = store.state.config.tyre;
  let arr = [];
  let arrange = ['front', 'middle', 'back'];
  arrange.forEach((e) => {
    arr.push(...generateCount(e, tyre[e]));
  });
  return ['general', ...arr];
}
function generateCount(key, obj) {
  let initial = key.charAt(0).toUpperCase();
  let sides = ['L', 'R'];
  let arr = [];
  for (let index = 0; index < obj.count; index++) {
    sides.forEach((side) => {
      arr.push(`${initial}${side}${index + 1}`);
    });
  }

  return arr;
}

const currentData = computed(() => {
  return store.state.tyre[position.value.model];
});

const ui = [
  { label: 'Pin Code', model: 'pincode', input: true },
  { label: 'Brand', model: 'brand', input: true },
  { label: 'Model', model: 'model', input: true },
  { label: 'Purchase Date', model: 'purchaseDate', input: true, type: 'date' },
  {
    label: 'Purchase Price (RM)',
    model: 'purchasePrice',
    input: true,
    type: 'number',
  },
  {
    label: 'Status at time of Purchase',
    model: 'purchaseStatus',
    options: ['NEW', 'USED SPARINGLY', 'OLD', 'CELUP'],
  },
  { label: 'Remarks', model: 'remarks', input: true, type: 'textarea' },
];

function modifyData(v, add) {
  rerender();
  if (add) {
    store.addNewTyre(v);
  } else {
    store.removeTyre(v);
  }
}

function rerender() {
  let go = position.value.model;
  setTimeout(() => {
    renderGeneral.value = false;
    position.value.model = 'general';
  }, 0);
  setTimeout(() => {
    position.value.model = go;
    renderGeneral.value = true;
  }, 1);
}
</script>

<style lang="scss" scoped></style>
